import { useRouteMatch } from 'react-router-dom';

import { getCheckoutPath } from 'common/helpers/routerHelper';

const useIsClubSignupProductRoute = () => {
  let isProductRoute = false;

  const match = useRouteMatch({
    path: getCheckoutPath('/club/product'),
    exact: true
  });
  if (match) {
    isProductRoute = true;
  }
  return isProductRoute;
};

export default useIsClubSignupProductRoute;
